import { useMutation } from "@tanstack/react-query";
import React, { useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { createReceiptWithData } from "../api/receipts.api";
import { queryError, showAlert } from "../utils/helpers";

const CreateReceiptModal = ({ show, close, onSuccessRefresh }) => {
    const initialState = {
        title: "",
        base64File: ""
      };
      const [formdata, setFormdata] = useState(initialState);
      const [fileName, setFileName] = useState("");

      const handleChange = (field, value) => {
        setFormdata((prevState) => ({
          ...prevState,
          [field]: value,
        }));
      };

      const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
          setFileName(file.name);
          const reader = new FileReader();
          reader.onloadend = () => {
             handleChange("base64File", reader.result);
          };
          reader.readAsDataURL(file);
        }
      };

      const {mutate:createReceipt, isLoading} = useMutation(createReceiptWithData,{
        onSuccess: data => {
          if(!data.status)return showAlert({
              title: "Oops!",
              msg: typeof data.errors[0]?.msg == "string"
              ? data.errors[0].msg
              : data.errors[0]?.msg?.message || data.message || "An error occurred",
              icon: "error",
              btnText: "Close" 
            });
            close();
            setFormdata(initialState);
            setFileName("");
            if (onSuccessRefresh) onSuccessRefresh();
            return showAlert({
              title: "Success",
              msg: "Receipt uploaded successfully",
              icon: "success",
              btnText: "Close" 
            });
      },
      onError: err => queryError()
      });

      const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formdata.base64File || !formdata.title) {
            return showAlert({title: "Oops", msg: "Please provide a title and select a file", icon: "error"});
        }
        createReceipt(formdata);
    };

  return (
    <Modal
      show={show}
      onHide={close}
      backdrop="static"
      keyboard={false}
      size={"md"}
    >
      <Modal.Header closeButton>
        <Modal.Title>Upload New Receipt</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formBasicTitle">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter a title for the receipt"
              onChange={(e) => handleChange("title", e.target.value)}
              value={formdata.title}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formFile">
            <Form.Label>Receipt File (PDF or Image)</Form.Label>
            <Form.Control 
              type="file" 
              accept=".pdf,image/*"
              onChange={handleFileChange} 
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={close} disabled={isLoading}>
          Close
        </Button>
        <Button
          onClick={handleSubmit}
          type="submit"
          variant="primary"
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <Spinner animation="border" size="sm" color="#fff" />{" "}
              Uploading... Please Wait
            </>
          ) : (
            "Upload Receipt"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CreateReceiptModal;
